module.exports = require("./dist/waves.js");
require("./dist/waves.css");


//////////////////
// WEBPACK FOOTER
// waves (bower component)
// module id = 1221
// module chunks = 1